import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ColDef, ICellRendererParams } from '@ag-grid-community/core';

@Component({
    selector: 'p-urls-list-renderer',
    template: `
        <div *ngFor="let link of links; last as _last" class="urls-list">
            <p-link [attr.automation-id]="link.automationId" [url]="link.url">{{ link.text }}</p-link>
            <span *ngIf="!_last">, </span>
        </div>
    `,
    styleUrls: ['./urls-list-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UrlsListRendererComponent implements ICellRendererAngularComp {
    links: { url: string; text: string; automationId: string }[] = [];

    agInit(params: UtilsListRendererParams): void {
        this.extractParams(params);
    }

    refresh(params: UtilsListRendererParams): boolean {
        this.extractParams(params);
        return true;
    }

    private extractParams(params: UtilsListRendererParams) {
        const { field } = params.colDef as ColDef;
        const linkValueSeparator = params.linkValueSeperator || ',';
        const valuesList: string[] | undefined = params.getValue?.()?.toString().split(linkValueSeparator);

        valuesList?.forEach((value: string) => {
            this.links.push({ text: value, url: params.buildUrl(value), automationId: field + '-' + value + '_urls-list' });
        });
    }
}

interface UtilsListRendererParams extends ICellRendererParams {
    linkValueSeperator: string;
    buildUrl: Function;
}
